import React, { Component } from 'react';

import { Form, Select, Col } from 'antd';

import service from '../../services';

const FormItem = Form.Item;

class Years extends Component {
    constructor(props) {
        super(props);


        this.state = {
            value: props.value,
            names: [],
            maps: {}
        };
    }

    componentDidMount() {
        this.querySearch();
    }

    querySearch() {
        return service.term
        .querySearchTermYear().then(data => {
            this.setState(Object.assign({}, this.state, {
                value: this.props.termIdYear,
            }, data));
        });
    }


    handleChange(data) {
        const domain = Object.assign({}, this.state, data);

        this.setState(domain);

        if(this.props.handleChange) {
            const params = {termIdYear: undefined, termNameYear: undefined};

            if(domain.termIdYear) {
                params.termIdYear = domain.termIdYear;
                params.termNameYear = domain.termNameYear;
            }

            this.props.handleChange(params);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('value')) {
            
            this.setState({
                value: nextProps.value
            });
        }
    }

    render() {
        const {style, label} = this.props;
        const {value, termNameYear} = this.state;
        return (
            <span>
                <FormItem label={label || '所属学年'}>
                    <Select
                        placeholder='请选择...'
                        allowClear={true}
                        value={value}
                        style={style || {width: 240}}
                        dropdownMatchSelectWidth={false}

                        onChange={(termIdYear) => {
                            this.handleChange({
                                termIdYear: termIdYear,
                                termNameYear: this.state.maps[termIdYear] ? this.state.maps[termIdYear].termName : ""
                            });
                        }}
                    >
                        {
                            this.state.names.map(value => (
                                <Option value={value}>{this.state.maps[value].termName}</Option>
                            ))
                        }
                    </Select>
                </FormItem>
            </span>
        );
    }
}

export default Years;